import type { SVGProps } from 'react';

/**
 * Happened brand mark — indigo rounded tile with a white "H" monogram and an
 * emerald "moment" dot. Drop-in replacement for the upstream Logo1Icon.
 * Accepts the same sizing props as a blocksuite icon (fontSize / width / height).
 */
export const HappenedMark = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 192 192"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <linearGradient id="hp-mark-bg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#6366F1" />
          <stop offset="1" stopColor="#4F46E5" />
        </linearGradient>
      </defs>
      <rect width="192" height="192" rx="44" fill="url(#hp-mark-bg)" />
      <rect x="50" y="48" width="22" height="96" rx="6" fill="#FFFFFF" />
      <rect x="120" y="48" width="22" height="96" rx="6" fill="#FFFFFF" />
      <rect x="64" y="85" width="64" height="22" rx="6" fill="#FFFFFF" />
      <circle
        cx="142"
        cy="50"
        r="13"
        fill="#34D399"
        stroke="url(#hp-mark-bg)"
        strokeWidth="5"
      />
    </svg>
  );
};
